export const aboutStrings = {
    label: "THIS IS",
    description: " 👨🏻‍💻  I'm Front-End Developer with almost 1 year of experience. Currently working in Vue 2/3. Feel free to reach me out via email",
    buttonLabel: "Hire Me",
    name: "Grzegorz Domin",
};